(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["carousel"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('theme-carousel')) {
    class ThemeCarousel extends HTMLElement {
      scrollNext() {
  const card = this.track.querySelector(':scope > *');
  const amount = card
    ? card.getBoundingClientRect().width + 16
    : this.track.clientWidth * 0.8;

  const isEnd =
    this.track.scrollLeft + this.track.clientWidth >=
    this.track.scrollWidth - 5;

  if (isEnd) {
    this.track.scrollTo({
      left: 0,
      behavior: 'smooth'
    });
  } else {
    this.track.scrollBy({
      left: amount,
      behavior: 'smooth'
    });
  }
}
      connectedCallback() {
        this.track = this.querySelector('[data-carousel-track]');
        this.prevButton = this.querySelector('[data-carousel-prev]');
        this.nextButton = this.querySelector('[data-carousel-next]');

        if (!this.track) return;

        this.prevButton?.addEventListener('click', () => this.scrollByCard(-1));
        this.nextButton?.addEventListener('click', () => this.scrollByCard(1));
        this.track.addEventListener('scroll', () => this.updateButtonState(), { passive: true });

        this.updateButtonState();
         this.autoScroll = setInterval(() => {
    this.scrollNext();
  }, 3000);
      }

      scrollByCard(direction) {
        const card = this.track.querySelector(':scope > *');
        const amount = card ? card.getBoundingClientRect().width + 16 : this.track.clientWidth * 0.8;
        this.track.scrollBy({ left: amount * direction, behavior: 'smooth' });
      }

      updateButtonState() {
        const { scrollLeft, scrollWidth, clientWidth } = this.track;
        if (this.prevButton) this.prevButton.disabled = scrollLeft <= 1;
        if (this.nextButton) this.nextButton.disabled = scrollLeft + clientWidth >= scrollWidth - 1;
      }
       
    }

    customElements.define('theme-carousel', ThemeCarousel);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cart-drawer')) {
    class CartDrawer extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        this.querySelectorAll('[data-cart-drawer-close]').forEach((button) => {
          button.addEventListener('click', () => this.close());
        });
        this.dialog.addEventListener('click', (event) => {
          if (event.target === this.dialog) this.close();
        });
        this.dialog.addEventListener('cancel', () => this.close());
      }

      open() {
        if (!this.dialog.open) this.dialog.showModal();
      }

      close() {
        if (this.dialog.open) this.dialog.close();
      }
    }

    customElements.define('cart-drawer', CartDrawer);
  }

  (function () {
    if (window.themeCart) return;

    async function fetchFreshCartMarkup() {
      const response = await fetch(window.location.href, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
      const html = await response.text();
      return new DOMParser().parseFromString(html, 'text/html');
    }

    async function refreshCartUI() {
      const doc = await fetchFreshCartMarkup();

      document.querySelectorAll('[data-cart-items]').forEach((liveNode) => {
        const freshNode = doc.querySelector('[data-cart-items]');
        if (freshNode) liveNode.innerHTML = freshNode.innerHTML;
      });

      document.querySelectorAll('[data-cart-subtotal]').forEach((liveNode) => {
        const freshNode = doc.querySelector('[data-cart-subtotal]');
        if (freshNode) liveNode.textContent = freshNode.textContent;
      });

      document.querySelectorAll('[data-cart-count]').forEach((liveNode) => {
        const freshNode = doc.querySelector('[data-cart-count]');
        if (freshNode) {
          liveNode.textContent = freshNode.textContent;
          liveNode.hidden = freshNode.hasAttribute('hidden');
        }
      });
    }

    async function addToCart(id, quantity) {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id, quantity: quantity || 1 }] }),
      });
      await refreshCartUI();
      document.querySelector('cart-drawer')?.open();
    }

    async function changeCartItem(key, quantity) {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity }),
      });
      await refreshCartUI();
    }

    window.themeCart = { addToCart, changeCartItem, refreshCartUI };

    document.addEventListener('click', (event) => {
      const opener = event.target.closest('[data-open-cart-drawer]');
      if (opener) {
        event.preventDefault();
        document.querySelector('cart-drawer')?.open();
      }

      const decreaseButton = event.target.closest('[data-qty-decrease]');
      const increaseButton = event.target.closest('[data-qty-increase]');
      const removeButton = event.target.closest('[data-cart-remove]');

      if (decreaseButton || increaseButton || removeButton) {
        const row = event.target.closest('[data-cart-item]');
        const stepper = event.target.closest('.quantity-stepper');
        const input = stepper?.querySelector('[data-qty-input]');
        if (!input) return;

        if (row && removeButton) {
          changeCartItem(row.dataset.key, 0);
          return;
        }

        const currentQty = parseInt(input.value, 10) || 0;
        const min = parseInt(input.min, 10) || 0;
        const nextQty = increaseButton ? currentQty + 1 : Math.max(min, currentQty - 1);
        input.value = nextQty;

        if (row) changeCartItem(row.dataset.key, nextQty);
      }
    });

    document.addEventListener('change', (event) => {
      const input = event.target.closest('[data-qty-input]');
      if (!input) return;
      const row = input.closest('[data-cart-item]');
      if (!row) return;
      const quantity = Math.max(0, parseInt(input.value, 10) || 0);
      changeCartItem(row.dataset.key, quantity);
    });

    document.addEventListener('submit', (event) => {
      const form = event.target.closest('[data-quick-add-form], [data-product-form]');
      if (!form) return;
      event.preventDefault();
      const idInput = form.querySelector('input[name="id"]');
      const qtyInput = form.querySelector('input[name="quantity"]');
      const submitButton = form.querySelector('[type="submit"]');
      if (submitButton) submitButton.disabled = true;
      addToCart(idInput.value, qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1).finally(() => {
        if (submitButton) submitButton.disabled = false;
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["popup-offer"] && !Shopify.designMode) return;
  try {
    (function () {
    var STORAGE_KEY = "ngs_offer_popup_dismissed";
    var DELAY_MS = 5000;

    var popup = document.querySelector("[data-offer-popup]");
    if (!popup) return;

    var overlay = popup.querySelector("[data-offer-popup-overlay]");
    var closeBtn = popup.querySelector("[data-offer-popup-close]");
    var form = popup.querySelector("[data-offer-popup-form]");
    var formState = popup.querySelector("[data-offer-popup-form-state]");
    var successState = popup.querySelector("[data-offer-popup-success]");
    var errorMsg = popup.querySelector("[data-offer-popup-error]");

    function alreadyDismissed() {
      try {
        return window.localStorage.getItem(STORAGE_KEY) === "1";
      } catch (e) {
        return false;
      }
    }

    function remember() {
      try {
        window.localStorage.setItem(STORAGE_KEY, "1");
      } catch (e) {}
    }

    function openPopup() {
      popup.setAttribute("data-open", "true");
      popup.setAttribute("aria-hidden", "false");
      document.body.classList.add("offer-popup-open");
    }

    function closePopup() {
      popup.setAttribute("data-open", "false");
      popup.setAttribute("aria-hidden", "true");
      document.body.classList.remove("offer-popup-open");
      remember();
    }

    if (!alreadyDismissed()) {
      setTimeout(openPopup, DELAY_MS);
    }

    if (overlay) overlay.addEventListener("click", closePopup);
    if (closeBtn) closeBtn.addEventListener("click", closePopup);

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && popup.getAttribute("data-open") === "true") closePopup();
    });

    var NAME_PATTERN = /^[a-zA-Z\s'.-]{2,}$/;
    var EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    function getInput(field) {
      return form ? form.querySelector('[data-field="' + field + '"]') : null;
    }

    function getErrorEl(field) {
      return form ? form.querySelector('[data-field-error="' + field + '"]') : null;
    }

    function showFieldError(field, message) {
      var input = getInput(field);
      var errorEl = getErrorEl(field);
      if (input) input.classList.add("offer-popup__input--error");
      if (errorEl) {
        errorEl.textContent = message;
        errorEl.hidden = false;
      }
    }

    function clearFieldError(field) {
      var input = getInput(field);
      var errorEl = getErrorEl(field);
      if (input) input.classList.remove("offer-popup__input--error");
      if (errorEl) {
        errorEl.textContent = "";
        errorEl.hidden = true;
      }
    }

    function validateField(field) {
      var input = getInput(field);
      if (!input) return true;
      var value = input.value.trim();

      if (field === "name") {
        if (!value) {
          showFieldError(field, "Please enter your name.");
          return false;
        }
        if (!NAME_PATTERN.test(value)) {
          showFieldError(field, "Please enter a valid name.");
          return false;
        }
      }

      if (field === "email") {
        if (!value) {
          showFieldError(field, "Please enter your email.");
          return false;
        }
        if (!EMAIL_PATTERN.test(value)) {
          showFieldError(field, "Please enter a valid email address.");
          return false;
        }
      }

      if (field === "phone") {
        var digits = value.replace(/[^0-9]/g, "");
        if (!value) {
          showFieldError(field, "Please enter your phone number.");
          return false;
        }
        if (digits.length < 8 || digits.length > 15) {
          showFieldError(field, "Please enter a valid phone number.");
          return false;
        }
      }

      clearFieldError(field);
      return true;
    }

    ["name", "email", "phone"].forEach(function (field) {
      var input = getInput(field);
      if (!input) return;
      input.addEventListener("blur", function () {
        validateField(field);
      });
      input.addEventListener("input", function () {
        if (input.classList.contains("offer-popup__input--error")) {
          validateField(field);
        }
      });
    });

    function validateForm() {
      var nameOk = validateField("name");
      var emailOk = validateField("email");
      var phoneOk = validateField("phone");
      return nameOk && emailOk && phoneOk;
    }

    if (form) {
      form.addEventListener("submit", function (e) {
        if (!validateForm()) {
          e.preventDefault();
          return;
        }

        if (errorMsg) errorMsg.hidden = true;

        var submitBtn = form.querySelector('[type="submit"]');
        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.textContent = "SENDING...";
        }

        // Form submits in background iframe (Shopify email automation triggers perfectly)
        setTimeout(function () {
          formState.style.display = "none";
          successState.style.display = "block";
          remember();
        }, 800);
      });
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    // Intercept every "quick add" form on the page (grid, carousel, "you may
  // also like", etc.) so Add to Cart doesn't reload/redirect the page —
  // instead it adds via AJAX and opens the cart sidebar drawer from header.liquid.
  document.addEventListener("submit", function (event) {
    const form = event.target.closest(".product-card__quick-add-form");
    if (!form) return;

    event.preventDefault();

    const submitBtn = form.querySelector('[type="submit"]');
    if (submitBtn) submitBtn.disabled = true;

    const formData = new FormData(form);

    fetch("/cart/add.js", {
      method: "POST",
      headers: { Accept: "application/json" },
      body: formData,
    })
      .then((res) => {
        if (!res.ok) return res.json().then((err) => Promise.reject(err));
        return res.json();
      })
      .then(function () {
        return fetch("/cart.js").then((res) => res.json());
      })
      .then(function (cart) {
        if (typeof window.refreshCartDrawer === "function") {
          window.refreshCartDrawer(cart);
        }
        if (typeof window.openCartDrawer === "function") {
          window.openCartDrawer();
        }
      })
      .catch(function (err) {
        console.error("Add to cart failed:", err);
      })
      .finally(function () {
        if (submitBtn) submitBtn.disabled = false;
      });
  });
  } catch(e) { console.error(e); }
})();

})();
